import { CardMedia, Tooltip } from '@mui/material';
import { DEFAULT_IMG_SOURCE } from 'modules/material/MaterialItem';
import { CSSProperties, memo } from 'react';

type Props = {
  fileName: string;
  imgStyles?: CSSProperties;
  displayTooltip?: boolean;
  thumbnailUrl: string;
  onClick?: () => void;
};

const FeaturedImage = (props: Props) => {
  const { fileName, thumbnailUrl, displayTooltip, imgStyles, onClick } = props;
  return (
    <Tooltip placement="top" title={displayTooltip ? fileName : undefined}>
      <CardMedia
        onError={e => (e.currentTarget.src = DEFAULT_IMG_SOURCE)}
        src={thumbnailUrl}
        component="img"
        onClick={onClick}
        sx={{
          width: '18.75rem',
          height: '12.5rem',
          ...imgStyles,
        }}
      />
    </Tooltip>
  );
};

export default memo(FeaturedImage);
